// extracted by mini-css-extract-plugin
module.exports = {"label":"ProfitCalculator_label__2TxMB"};